import styled from 'styled-components';
import { SecondaryButton } from 'ui/button';
import { WarningFill16 } from 'ui/icons';
import { Link } from 'ui/links';
import { TableHeader } from 'ui/tableHeader';
import { TableRows } from 'ui/tableRows';
import {
  H4,
  body2,
  borderColors,
  borderRadius,
  colors,
  spacing,
  subtitle1,
  subtitle2,
} from 'ui/theme';
import { pxToRem } from 'utils/convert';

export const PageHeaderLabel = styled.div`
  display: flex;
  align-items: center;
  gap: ${spacing.half};
`;

export const PageBody = styled.section`
  display: flex;
  gap: ${spacing.doubleQuarter};
  margin-top: ${spacing.double};
`;

export const TextContent = styled.div`
  width: ${pxToRem(325)};
`;

export const StyledSubheader = styled(H4)`
  margin-bottom: ${spacing.half};
`;

export const StyledSubtitle = styled.div`
  ${subtitle1}
  color: ${colors.textSecondary};
  margin: unset;
`;

export const TableContainer = styled.div`
  flex-grow: 1;
  border: 1px solid ${borderColors.borderPrimary};
  border-radius: ${borderRadius.md};
`;

export const StyledTableHeader = styled(TableHeader)`
  > div {
    padding: ${spacing.base} ${spacing.threeQuarter};
  }
`;

export const SectionHeader = styled.div`
  ${subtitle2}
  padding: ${spacing.threeQuarter};
  background: ${colors.backgroundTertiary};
  border-radius: ${borderRadius.md} ${borderRadius.md} 0 0;
`;

export const StyledTableRows = styled(TableRows)`
  > div {
    background-color: ${colors.white};
    border-radius: 0 0 ${borderRadius.md} ${borderRadius.md};
  }
  &:not(:last-child) {
    border-bottom: ${spacing.single} solid ${colors.grey15};
  }
`;

export const RowCell = styled.div`
  ${body2};
  display: table-cell;
  box-sizing: border-box;
  padding: ${spacing.threeQuarter};
  vertical-align: middle;
`;

export const ActionButtonContainer = styled.div`
  display: flex;
  gap: ${spacing.half};
  align-items: center;
  justify-content: flex-end;
`;

export const StyledLink = styled(Link)`
  font-size: inherit;
  color: ${colors.link};
  border-bottom: unset;
`;

export const BossRow = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  color: ${colors.textDestructive};
`;

export const IntegrationTableButton = styled(SecondaryButton)`
  padding: ${spacing.half};
`;

export const StyledWarningIcon = styled(WarningFill16)`
  path {
    fill: ${colors.iconWarning} !important;
  }
`;
